import * as types from './types/getters';
export default {
    [types.SHOW_POPUP](state) {
        return state.showPopup;
    },
};



// WEBPACK FOOTER //
// ./src/core/store/bookings/getters.ts